import {
	Card,
	CardContent,
	CardHeader,
	CardTitle,
	CardDescription,
} from '@/components/ui/card'
import { CodeBlock } from '../CodeBlock'
import { SectionHeader } from '../SectionHeader'
import { useTranslation } from '@/hooks/useTranslation'

export const WidgetControlApiSection = () => {
	const { t } = useTranslation()
	
	return (
		<section id="widget-control-api" className="mb-16">
			<SectionHeader id="widget-control-api">
				{t('docs.widgetControlApi.title')}
			</SectionHeader>

			<Card className="mb-8 shadow-sm dark:bg-gray-800/50">
				<CardHeader>
					<CardTitle className="text-xl font-semibold">
						{t('docs.widgetControlApi.methods.title')}
					</CardTitle>
					<CardDescription className="dark:text-gray-400">
						{t('docs.widgetControlApi.methods.description')}
					</CardDescription>
				</CardHeader>
				<CardContent className="text-gray-700 dark:text-gray-300 space-y-4">
					<p>
						{t('docs.widgetControlApi.methods.intro.prefix')}{' '}
						<code className="bg-gray-200 dark:bg-gray-700 px-1 py-0.5 rounded text-xs font-mono">
							window.feedbask
						</code>{' '}
						{t('docs.widgetControlApi.methods.intro.suffix')}
					</p>

					<div className="grid md:grid-cols-2 gap-4">
						<div className="p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-200 dark:border-blue-700">
							<h4 className="font-semibold text-blue-800 dark:text-blue-200 mb-2">
								{t('docs.widgetControlApi.basicControl.title')}
							</h4>
							<ul className="text-sm text-blue-700 dark:text-blue-300 space-y-1">
								<li>
									• <strong>open():</strong>{' '}
									{t('docs.widgetControlApi.basicControl.open')}
								</li>
								<li>
									• <strong>close():</strong>{' '}
									{t('docs.widgetControlApi.basicControl.close')}
								</li>
								<li>
									• <strong>isOpen():</strong>{' '}
									{t('docs.widgetControlApi.basicControl.isOpen')}
								</li>
								<li>
									• <strong>getCurrentSection():</strong>{' '}
									{t('docs.widgetControlApi.basicControl.getCurrentSection')}
								</li>
							</ul>
						</div>
						<div className="p-4 bg-green-50 dark:bg-green-900/20 rounded-lg border border-green-200 dark:border-green-700">
							<h4 className="font-semibold text-green-800 dark:text-green-200 mb-2">
								{t('docs.widgetControlApi.sectionNavigation.title')}
							</h4>
							<ul className="text-sm text-green-700 dark:text-green-300 space-y-1">
								<li>
									• <strong>openBug():</strong>{' '}
									{t('docs.widgetControlApi.sectionNavigation.openBug')}
								</li>
								<li>
									• <strong>openFeature():</strong>{' '}
									{t('docs.widgetControlApi.sectionNavigation.openFeature')}
								</li>
								<li>
									• <strong>openReview():</strong>{' '}
									{t('docs.widgetControlApi.sectionNavigation.openReview')}
								</li>
								<li>
									• <strong>openFeedback():</strong>{' '}
									{t('docs.widgetControlApi.sectionNavigation.openFeedback')}
								</li>
								<li>
									• <strong>openMessage():</strong>{' '}
									{t('docs.widgetControlApi.sectionNavigation.openMessage')}
								</li>
								<li>
									• <strong>openRoadmap():</strong>{' '}
									{t('docs.widgetControlApi.sectionNavigation.openRoadmap')}
								</li>
							</ul>
						</div>
					</div>
				</CardContent>
			</Card>
		</section>
	)
}